/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */

/**
 * 文件系统配额类型
 */
export enum FsQuotaTypeE {
    /**
     * 用户配额
     */
    USER = 'user',
    /**
     * 用户组配额
     */
    GROUP = 'group',
}

/**
 * 文件系统配额名称类型
 */
export enum FsQuotaNameTypeE {
    /**
     * 用户
     */
    USER = 'user',
    /**
     * 用户组
     */
    GROUP = 'group',
}
